import '../airbrake';
import Vue from 'vue';
import VueRouter from 'vue-router';
import Toasted from 'vue-toasted';
import App from '@/auth/App.vue';
import router from '@/auth/router';
import '@/auth/styles.css';

Vue.use(VueRouter);
Vue.use(Toasted);

interface Flash {
  notice?: string;
  alert?: string;
}

declare global {
  interface Window {
    __FLASH__?: Flash;
  }
}

const toastOptions = {
  theme: 'toasted-primary' as const,
  position: 'top-right' as const,
  duration: 5000,
  class: 'spireworks_toast',
  containerClass: 'spireworks_toast_container',
};

function showFlashMessages() {
  const flash = window.__FLASH__;
  if (!flash) return;

  if (flash.notice) {
    Vue.toasted.show(flash.notice, {
      type: 'info',
      ...toastOptions,
    });
  }

  if (flash.alert) {
    Vue.toasted.show(flash.alert, {
      type: 'error',
      ...toastOptions,
    });
  }

  delete window.__FLASH__;
}

const mountApp = () => {
  const mountPoint = document.getElementById('auth-app');
  if (mountPoint) {
    new Vue({
      router,
      render: h => h(App),
    }).$mount('#auth-app');

    showFlashMessages();
  } else {
    console.error('Mount point #auth-app not found');
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountApp);
} else {
  mountApp();
}
